import { NgModule } from "@angular/core";
import { DialogSuperStarsComponent } from "./dialog-super-stars.component";

@NgModule({
  imports: [DialogSuperStarsComponent],
})
export class DialogSuperStarsModule {}
